(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slideshow-slide"] && !Shopify.designMode) return;
  try {
    class SlideshowVideo extends HTMLElement {
    connectedCallback() {
      this.autoplay = this.dataset.autoplay === 'true';
      this.desktopVideo = this.querySelector('[data-video-desktop] video');
      this.mobileVideo = this.querySelector('[data-video-mobile] video');
      this.mediaQuery = window.matchMedia('(min-width: 780px)');
      this.handleChange = this.handleChange.bind(this);
      this.mediaQuery.addEventListener('change', this.handleChange);
      this.handleChange();
    }
 
    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.handleChange);
    }
 
    handleChange() {
      var showDesktop = this.mediaQuery.matches;
      this.setActive(this.desktopVideo, showDesktop);
      this.setActive(this.mobileVideo, !showDesktop);
    }
 
    setActive(video, isActive) {
      if (!video) return;
      if (isActive) {
        if (this.autoplay) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }
      } else if (!video.paused) {
        video.pause();
      }
    }
  }
 
  if (!customElements.get('slideshow-video')) {
    customElements.define('slideshow-video', SlideshowVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    const videos = document.querySelectorAll('.ugc-gallery-content--wrapper [video-thumb]');
  const videoDetail = document.getElementById('ugc-video-details');
  const videoDetailSource = document.getElementById('ugc-video-details-source');
  const modal = document.querySelector('.UGCDetailsModal');
  videos.forEach((video) => {
    video.addEventListener('click', () => {
      if (modal) {
        modal.show();
        videoDetailSource.src = video.currentSrc; // Set video source
        videoDetail.load();
        videoDetail.muted = false;
        videoDetail.play();
      }
    });
  });
  document.body.addEventListener('modalClosed', () => {
    videoDetailSource.src = null;
    videoDetail.muted = true;
    videoDetail.pause();
  });

  window.pauseAllMedia = () => {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  };

  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    hide() {
      let isOpen = false;
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
    }
  }

  customElements.define('modal-dialog', ModalDialog);

  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }

  customElements.define('modal-opener', ModalOpener);
  } catch(e) { console.error(e); }
})();

})();
